module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ac973b51892f4a335817a8509bc79a0a.gif";